export class NiveauAccesDiplome {
    constructor(
        public idNiveauAccesDiplome?: number,
        public niveau?: number,
        public libelle?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/niveau-acces-diplome.model.ts